import 'core-js/modules/es.array.concat.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

var NotificationDot = function NotificationDot(_ref) {
  var children = _ref.children,
    hidden = _ref.hidden,
    elevated = _ref.elevated,
    inverted = _ref.inverted,
    themeProps = _ref.themeProps;
  return jsxs("span", {
    className: "cogs-v10 cogs-notification-dot",
    children: [jsx("span", {
      className: "cogs-v10 cogs-notification-dot__element",
      children: children
    }), !hidden && jsx("div", {
      className: classNames.apply(undefined, ['cogs-v10', 'cogs-notification-dot__bubble', elevated && 'cogs-notification-dot__bubble--elevated'].concat(getThemeClassNames(inverted, themeProps))),
      role: "complementary"
    })]
  });
};

export { NotificationDot };
